import { createApi } from '@reduxjs/toolkit/query/react';
import { Activity } from '../../models/activity';
import axiosBaseQuery from '../../services/api/axiosBaseQuery';
import {
  EmployeesApiUrl,
  GetEmployeeActivities,
} from '../../services/api/employeeServices';
import { ApiResponse } from '../../services/httpService';
import { ActivitiesApiURL } from '../../services/api/activityServices';
import { convertMinutesToHours } from '../../services/conversionService';

export const activitiesService = createApi({
  reducerPath: 'activitiesService',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Activity'],

  endpoints: (builder) => ({
    getActivities: builder.query<Activity[], GetEmployeeActivities>({
      query: ({ internalId, ...params }) => ({
        url: `${EmployeesApiUrl}/${internalId}/Activities`,
        params,
      }),
      providesTags: ['Activity'],

      transformResponse: (response: ApiResponse<Activity>) => {
        return response.items.map((activity) => {
          activity.hours = convertMinutesToHours(activity.minutes);

          return activity;
        });
      },

      keepUnusedDataFor: 30,
    }),

    addActivity: builder.mutation<void, Partial<Activity>>({
      query: (newActivity: Partial<Activity>) => ({
        url: ActivitiesApiURL,
        method: 'POST',
        data: newActivity,
      }),
      invalidatesTags: ['Activity'],
    }),

    editActivity: builder.mutation<
      void,
      {
        idActivity: string;
        editActivityInfo: Partial<Activity>;
      }
    >({
      query: ({ idActivity, editActivityInfo }) => ({
        url: `${ActivitiesApiURL}/${idActivity}`,
        method: 'PUT',
        data: editActivityInfo,
      }),
      invalidatesTags: ['Activity'],
    }),
    deleteActivity: builder.mutation<void, string>({
      query: (idActivity: string) => ({
        url: `${ActivitiesApiURL}/${idActivity}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Activity'],
    }),
  }),
});

export const {
  useGetActivitiesQuery,
  useAddActivityMutation,
  useEditActivityMutation,
  useDeleteActivityMutation,
} = activitiesService;
